import Swiper, { Lazy, Navigation } from "swiper";

const Production = {
  init() {
    this.events();
    Production.gallery();
  },

  events() {

    $('.page-video').on('click', function (){
      let videoUrl = $(this).attr('data-video')
      videoUrl = videoUrl.split('https://www.youtube.com/embed/')
      $('.page-video').html(`<iframe src="https://www.youtube.com/embed/${videoUrl[1]}?controls=0&autoplay=1&mute=1&playsinline=1&playlist=${videoUrl[1]}&loop=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`)
    })

  },

  gallery() {
    const slider_dom = $(".gallery-slider");

    if (!slider_dom.length) {
      return;
    }

    const wrap = slider_dom.closest(".project-gallery");

    const nav_prev = wrap.find(".swiper-button-prev");

    const nav_next = wrap.find(".swiper-button-next");

    const slides_count = $(".project-gallery").find(".swiper-slide");
    const slides_count_dup = $(".project-gallery").find(".swiper-slide-duplicate");

    new Swiper( slider_dom[0], {
      spaceBetween: 30,
      slidesPerView: 1,
      loop: true,
      modules: [ Lazy, Navigation ],
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        prevEl: nav_prev[0],
        nextEl: nav_next[0],
      },
      on: {
        init: function (e){
          $('#currentSlide').html( (e.realIndex +  1) + ' / ' + (slides_count.length - slides_count_dup.length) );
        },
        slideChange: function (e){
          $('#currentSlide').html( (e.realIndex +  1) + ' / ' + (slides_count.length - slides_count_dup.length) );
        }
      },
    });
  },

};

export default Production;
